// validators.ts for Scheduler
import * as _ from 'underscore';

import { validators as appValidators } from '../../../_common/application/ts/validators';
import AttrQueryField from './components/AttrQueryField';
import { IAttrQuery, ISingleCardConfig, IDataQuery, CARD_TYPE_ENUM } from './components/Interfaces';
import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';

import * as Constants from '../ts/components/Constants';
import { IQueryFilter } from '../../../_common/platform/tsx/filtering/Interfaces';

export const validators = {
    number: {
        countInteger: function (value) {
            if (typeof value.count === 'number' && !isNaN(value.count)) {
                return;
            }

            return ['Count value should be a number'];
        },
        countPositive: function (value) {
            if (typeof value.count !== 'number' || isNaN(value.count)) {
                return;
            }

            if (value.count > 0) {
                return;
            }

            return ['Count value should be a positive number'];
        },
        heightInteger: function (value) {
            if (typeof value.height === 'number' && !isNaN(value.height)) {
                return;
            }

            return ['Height value should be a number'];
        },
        heightPositive: function (value) {
            if (typeof value.height !== 'number' || isNaN(value.height)) {
                return;
            }

            if (value.height > 0) {
                return;
            }

            return ['Height value should be a positive number'];
        },
        widthInteger: function (value) {
            if (typeof value.width === 'number' && !isNaN(value.width)) {
                return;
            }

            return ['Width value should be a number'];
        },
        widthPositive: function (value) {
            if (typeof value.width !== 'number' || isNaN(value.width)) {
                return;
            }

            if (value.width > 0) {
                return;
            }

            return ['Width value should be a positive number'];
        },
        number: function (value) {
            if (typeof value !== 'number' || !isNaN(Number(value))) {
                return;
            }
            return ['Value should be a number'];
        }
    },

    attrquery_cards: {
        cardValidator: function (value) {
            var valid = true;

            var errors = [];

            var valids = _.filter(value, (cardConfig: ISingleCardConfig) => {
                var _sortOrderForCardID = validators.attrquery_cards.validateSortOrderForCardID(
                    this.glob,
                    cardConfig.dataCard
                );
                errors = errors.concat(_sortOrderForCardID.errors);

                return (
                    validators.attrquery_cards.validateAttrQuery1(
                        this.glob,
                        cardConfig.dataCard.cardType,
                        cardConfig.dataCard.attrQuery
                    ).valid === true &&
                    validators.attrquery_cards.validateAttrQuery2(
                        this.glob,
                        cardConfig.dataCard.cardType,
                        cardConfig.dataCard.attrQuery1
                    ).valid === true &&
                    _sortOrderForCardID.valid === true &&
                    validators.attrquery_cards.validateFilter(this.glob, cardConfig.dataCard.attrQueryFilter).valid ===
                        true &&
                    (value.attrQueryFilter1 == null ||
                        validators.attrquery_cards.validateFilter(this.glob, value.attrQueryFilter1).valid === true)
                );
            });

            if (valids.length === value.length) {
                return [];
            } else {
                var total = value.length;
                var invalids = value.length - valids.length;
                return [`${invalids} of ${total} Data Queries are not valid`].concat(errors);
            }
        },

        shouldHaveRole: function (value) {
            var find = _.find<any>(value, (obj) => {
                return obj.role == null || obj.role === 'none';
            });

            if (find != null) {
                return ['Role should be specified for all Attributes'];
            }
        },

        roleUnique: function (vals, RoleList) {
            return function (value) {
                var count = _.countBy<any>(value, (obj) => {
                    return obj.role || 'none';
                });

                var find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return false;
                    }
                    return count[val] > 1;
                });

                if (find != null && RoleList != null) {
                    if (RoleList[find] != null) find = '"' + RoleList[find] + '"';
                    return ['Role value ' + find + ' can be set only once'];
                }
            };
        },

        roleRequire: function (vals, RoleList) {
            return function (value) {
                var count = _.countBy<any>(value, (obj) => {
                    return obj.role || 'none';
                });

                var find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return true;
                    }
                    return count[val] === 0;
                });

                if (find != null) {
                    if (RoleList[find] != null) {
                        find = '"' + RoleList[find] + '"';
                    }
                    return ['Role value ' + find + ' must be specified'];
                }
            };
        },

        attributeSelected: function (value: IAttrQuery[]) {
            if (value == null || value.length == 0) {
                return;
            }

            var hasEmpty = false;

            _.map(value, (obj: any) => {
                if (obj.attribute == AttrQueryField.empty_attribute) {
                    hasEmpty = true;
                } else {
                    let attr = obj.attribute && obj.attribute.trim();
                    if (attr === AttrQueryField.empty_attribute) {
                        hasEmpty = true;
                    }
                    return attr;
                }
            });

            var ret = [];
            if (hasEmpty) {
                ret.push('Empty Attribute prohibited');
            }

            if (ret.length > 0) {
                return ret;
            }
        },

        validateGroupingAttributes: (value: IAttrQuery[]) => {
            if (value != null && value.length > 0) {
                const attrQueries = value;

                var numberOfAttributes = attrQueries != null ? attrQueries.length : 0;
                if (numberOfAttributes === 0) {
                    return null;
                }
                var virtualEntitiesCount = _.countBy<any>(value, (obj) => {
                    return obj.attribute === '#Delta' || obj.attribute === '#DeltaPCT';
                });
                numberOfAttributes = numberOfAttributes;
                let attributesWithAggregation: number = 0;
                let attributesWithoutAggregation: number = 0;
                let attributesWithGrouping: number = 0;
                let expression: number = 0;
                for (let i = 0; i < numberOfAttributes; i++) {
                    const aggregate = attrQueries[i].aggregateGroup;

                    if (attrQueries[i].expression != null) {
                        expression++;
                    }
                    if (aggregate == null || aggregate === 'none' || aggregate === '' /* || valueType != 'variable'*/) {
                        attributesWithoutAggregation++;
                    } else {
                        if (aggregate === 'group') {
                            attributesWithGrouping++;
                        }

                        attributesWithAggregation++;
                    }
                }

                if (attributesWithAggregation > 0) {
                    if (attributesWithoutAggregation - virtualEntitiesCount.true - expression > 0) {
                        return ['Either all or none of attributes must have aggregation function'];
                    } else if (attributesWithGrouping === numberOfAttributes - virtualEntitiesCount.true) {
                        return ['At least one non grouping attribute must exist'];
                    }
                }
            }
            return null;
        },

        initValidatorsQuery1: (glob, cardType) => {
            let validatorsLocal = [appValidators.attrQuery.notEmpty, appValidators.attrQuery.aggregationsNoneOrAll];
            let RoleValuesList = {};
            let RequiredVal = {};

            switch (cardType) {
                case CARD_TYPE_ENUM.FREE: {
                    break;
                }

                case CARD_TYPE_ENUM.BOTH_VALS_FOR_DIFF_IN_SINGLE_QUERY: {
                    RequiredVal = Constants.RequiredRoles1;
                    RoleValuesList = Constants.Preset1Roles;
                    break;
                }
                case CARD_TYPE_ENUM.USE_2_SEPARATE_QUERIES: {
                    RequiredVal = Constants.RequiredRoles2Query1;
                    RoleValuesList = Constants.Preset2RolesQuery1;
                    break;
                }
                case CARD_TYPE_ENUM.USE_TOP2_GROUPING: {
                    RequiredVal = Constants.RequiredRoles3;
                    RoleValuesList = Constants.Preset3Roles;
                    break;
                }
            }

            validatorsLocal.push(validators.attrquery_cards.roleUnique(Constants.uniqVal, RoleValuesList));
            validatorsLocal.push(validators.attrquery_cards.roleRequire(RequiredVal, RoleValuesList));
            validatorsLocal.push(validators.attrquery_cards.attributeSelected);
            validatorsLocal.push(validators.attrquery_cards.validateGroupingAttributes);

            return new ParameterFieldBase<IParameterFieldBaseOptions>(glob, '', validatorsLocal, []);
        },

        initValidatorsQuery2: (glob, cardType: CARD_TYPE_ENUM) => {
            let validatorsLocal = [];
            switch (cardType) {
                case CARD_TYPE_ENUM.FREE: {
                    break;
                }
                case CARD_TYPE_ENUM.BOTH_VALS_FOR_DIFF_IN_SINGLE_QUERY: {
                    validatorsLocal = [appValidators.attrQuery.aggregationsNoneOrAll];
                    break;
                }
                case CARD_TYPE_ENUM.USE_2_SEPARATE_QUERIES: {
                    validatorsLocal = [
                        appValidators.attrQuery.notEmpty,
                        appValidators.attrQuery.aggregationsNoneOrAll,
                        validators.attrquery_cards.shouldHaveRole,
                        validators.attrquery_cards.roleUnique(Constants.uniqVal, Constants.Preset2RolesQuery2),
                        validators.attrquery_cards.roleRequire(
                            Constants.RequiredRoles2Query2,
                            Constants.Preset2RolesQuery2
                        )
                    ];
                    break;
                }
                case CARD_TYPE_ENUM.USE_TOP2_GROUPING: {
                    validatorsLocal = [appValidators.attrQuery.aggregationsNoneOrAll];
                    break;
                }
            }
            validatorsLocal.push(validators.attrquery_cards.attributeSelected);
            validatorsLocal.push(validators.attrquery_cards.validateGroupingAttributes);

            return new ParameterFieldBase<IParameterFieldBaseOptions>(glob, '', validatorsLocal, []);
        },

        initFilterValidator: (glob) => {
            return new ParameterFieldBase<IParameterFieldBaseOptions>(
                glob,
                '',
                [appValidators.localFilter.validate],
                [],
                {}
            );
        },

        validateAttrQuery1: (glob, cardType, value) => {
            var validator = validators.attrquery_cards.initValidatorsQuery1(glob, cardType);

            validator.validate(value);
            let errors = validator.errors;
            let valid = errors == null || errors.length === 0;

            return { valid: valid, errors: errors };
        },

        validateAttrQuery2: (glob, cardType, value) => {
            if (value == null || value.length === 0) {
                return { valid: true, errors: [] };
            }

            var validator = validators.attrquery_cards.initValidatorsQuery2(glob, cardType);

            validator.validate(value);
            let errors = validator.errors;
            let valid = errors == null || errors.length === 0;

            return { valid: valid, errors: errors };
        },

        validateFilter: (glob, value: IQueryFilter[]) => {
            var validator = validators.attrquery_cards.initFilterValidator(glob);

            validator.validate(value);
            let errors = validator.errors;
            let valid = errors == null || errors.length === 0;

            return { valid: valid, errors: errors };
        },

        validateSortOrderForCardID: function (glob, dataCard: IDataQuery) {
            // if (dataCard.cardType === CARD_TYPE_ENUM.USE_2_SEPARATE_QUERIES) {

            //     if (dataCard.limit !== 0) {

            //         let cardIDField0 = _.find(dataCard.attrQuery, (aq0) => {
            //             return aq0.role === 'ID';
            //         })

            //         let cardIDField1 = _.find(dataCard.attrQuery1, (aq1) => {
            //             return aq1.role === 'ID';
            //         })

            //         if (cardIDField0 && cardIDField1 &&
            //             (cardIDField0.sort == null || cardIDField1.sort == null || cardIDField0.sort !== cardIDField1.sort)) {
            //             return { valid: false, errors: ["Fields with CardID role should have the same sort order, and both shouldn't be 'none'"] }
            //         }
            //     }
            // }

            return { valid: true, errors: [] };
        }
    }
};
